export const FILE    = 'file';
export const VPAID   = 'vpaid';
export const VAST    = 'vast';
export const FLASH   = 'flash';
export const UNKNOWN = 'unknown';


// WEBPACK FOOTER //
// ./src/Media/MediaFormats.js